import { translation } from '@/plugins/i18n';
import { planTypes } from '@/common/constants';

export const getViewCurrentPlanName = (plan = {}) => {
  const planType = plan.type;
  const prefix = translation(plan?.planNameKey);
  if ([planTypes.LARGE_MEETING, planTypes.WEBINAR].includes(planType)) {
    return `${prefix} | ${plan.capacity} ${translation('billing.participants')}`;
  }

  return prefix;
};
